import type { LucideIcon } from "lucide-react";
import { FileText, Globe, Image as ImageIcon } from "lucide-react";

interface ItemTypeConfig {
  icon: LucideIcon;
  color: string;
  bg?: string;
}

const ITEM_TYPE_CONFIGS: Record<string, ItemTypeConfig> = {
  website: { icon: Globe, color: "text-blue-600", bg: "bg-blue-50" },
  image: { icon: ImageIcon, color: "text-purple-600", bg: "bg-purple-50" },
  text: { icon: FileText, color: "text-orange-600", bg: "bg-orange-50" },
};

const FALLBACK_ITEM_TYPE_CONFIG: ItemTypeConfig = {
  icon: Globe,
  color: "text-muted-foreground",
  bg: "bg-muted",
};

export function getItemTypeConfig(format: string): ItemTypeConfig {
  return ITEM_TYPE_CONFIGS[format] ?? FALLBACK_ITEM_TYPE_CONFIG;
}
